import {
  getFirestore,
  doc,
  setDoc,
  getDocs,
  query,
  where,
  collection,
} from "firebase/firestore";

import { db } from "../firebase";
import Cookies from "js-cookie";

export const Savemessagesystem = async (data) => {
  if (!data?.uid) {
    return { success: false, error: "Missing UID for user document." };
  }

  if (!data?.phone) {
    return { success: false, error: "Missing phone number." };
  }

  try {
    // Check if a similar unread message already exists
    const checkQuery = query(
      collection(db, "messagesystem"),
      where("phone", "==", data.phone),
        where("accountguid", "==", data.accountguid),
      where("read", "==", false)
    );

    const checkSnap = await getDocs(checkQuery);

    if (!checkSnap.empty) {
      return { success: false, error: "Already sent." };
    }

    const docRef = doc(db, "messagesystem", data.uid);
    const timestamp = new Date();

    const savequery = {
      ...data,
      login_name: Cookies.get("login_name") || "login_name",
      guid: Cookies.get("guid") || "",
      ip: Cookies.get("ipaddress") || "",
      device: typeof navigator !== "undefined" ? navigator.userAgent : "",
      date_time: timestamp,
      update_date_time: timestamp,
      save: false,
      status: true,
      read: false,
      ip:Cookies.get("ipaddres") || "",
        city: Cookies.get("city") || "",
      city: Cookies.get("city") || "",
      postcode: Cookies.get("postcode") || "",
      state: Cookies.get("state") || "",
      country: Cookies.get("country") || "",
    };

    await setDoc(docRef, savequery);
    return { success: true };

  } catch (err) {
    console.error("Error saving message system:", err);
 return { success: false, error: err.message || "Unknown error" };
  }
};
